<template>
  <div class="ine-form__additional-links">
    <div
      v-if="isLinkShown('newAccount')"
      class="ine-form__link-wrapper ine-form__link-wrapper--signup"
    >
      <p class="ine-form__link-wrapper--lead">
        Don't Have an Account?
      </p>
      <a
        :href="`//${checkoutUrl}/starter-pass`"
        class="ine-form__link ine-form__link--signup"
      >
        Get started for free with the INE Starter Pass
      </a>
    </div>
    <router-link
      v-if="isLinkShown('login')"
      :to="{ name: 'login' }"
      class="ine-form__link"
    >
      Login
    </router-link>
    <router-link
      v-if="isLinkShown('forgotPassword')"
      :to="{ name: 'forgot-password' }"
      class="ine-form__link"
    >
      Forgot Password
    </router-link>
    <a
      v-if="isLinkShown('plans')"
      class="ine-form__link"
      target="_blank"
      rel="noopener"
      :href="`//${plansLink}`"
      >Learn More About Our Plans</a
    >
    <div class="ine-form__link-wrapper">
      <router-link
        class="ine-form__link ine-form__homepage-link"
        :to="{ name: 'home' }"
        >Back to Homepage</router-link
      >
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'AdditionalLinks',
  props: {
    linksShown: {
      type: Array,
      required: true,
    },
  },
  computed: {
    ...mapState({
      plansLink: state => state.app.plansLink,
    }),
    checkoutUrl() {
      return process.env.VUE_APP_CHECKOUT_URL
    },
  },
  methods: {
    isLinkShown(name) {
      return this.linksShown.includes(name)
    },
  },
}
</script>
